import React from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell } from "@mui/material";

/**
 * Reusable table row component for displaying key-value pairs in run details
 */
const DetailsTableRow = ({ label, value, format }) => {
  const formatValue = (val) => {
    if (format === "number" && typeof val === "number") {
      return val.toLocaleString();
    }
    return val || "N/A";
  };

  return (
    <TableRow>
      <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
        {label}
      </TableCell>
      <TableCell>{formatValue(value)}</TableCell>
    </TableRow>
  );
};

DetailsTableRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  format: PropTypes.oneOf(["number"]),
};

export default DetailsTableRow;
